export default "__VITE_ASSET__CUvqa9mO__"